import React, {useMemo, useEffect,useState } from "react";
import withRouter from "../../../../Components/Common/withRouter";

import axios from 'axios'
import { subscribeToTokenRefresh } from "../../../../helpers/Refreshfile";
import { Card, CardBody, CardTitle,Col, Row, Alert} from "reactstrap";

import TableContainer from "../../../../Components/Common/TableContainer";

import { useDispatch } from "react-redux";
import { blogStatsDataType } from "./type";

import defaultImg from "../../../../assets/images/defaultuserimgdark.png"

const baseUrl = process.env.REACT_APP_BASE_URL;


const LatestBooking: React.FC = () => {


  const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const [showloader, setshowloader] = useState(true)

  const dispatch = useDispatch<any>();
  const columns = useMemo(() => [
    {
      header: "Customer Info",
      accessorFn: (row: any) => {
        const first_name = row?.expert?.user?.first_name || '';
        const email = row?.expert?.user?.email || '';
        return `${first_name} ${email}`;
      },
      enableColumnFilter: false,
      enableSorting: true,
      cell: (info: any) => {
        const row = info.row.original;
        const first_name = row?.expert?.user?.first_name || "No first name";
        const email = row?.expert?.user?.email || "No email";
        const attachment = row?.expert?.user?.profile_pic;
    
        return (
          <div className="d-flex align-items-center">
            <img
              src={attachment ? `${baseUrl}${attachment}` : defaultImg}
              alt="Customer Profile"
              width="50"
              height="50"
              className="rounded-circle"
              style={{ marginRight: '10px', objectFit: 'cover' }}
            />
            <div>
              <div className="fw-medium">{first_name || "No first name"}</div>
              <div className="font-size-12">{email || "No email"}</div>
            </div>
          </div>
        );
      }
    }
    ,
    {
      header: "Phone",
      accessorKey: "expert.user.phone",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Booking Date",
      accessorKey: "seldate",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }: any) => { return ( <> {row.original.seldate} <br /> {row.original.seltimes?.hour} </> ); },
    },
    {
      header: 'Category',
      accessorKey: 'expert.category',
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }: any) => {
          const category = row.original.expert?.category;
          if (category) {
            const subcategories = row.original.expert?.subcategory.name;
      
            return (
              <>
                {category.name} <br /> {subcategories}  
              </>
            );
          }
          return 'No category available';  
        },
  },
  

    
  ], []);

  const [latestBooking, setlatestBooking] = useState<any[]>([]);
  const [Bookingcount, setBookingcount] = useState<any[]>([]);
        const fetch_bookings = async () => {
        // let userId = localStorage.getItem('authUser');     
        // let user_role = localStorage.getItem('userole_');  
          try {
            setshowloader(true)
            const response = await axios.post(
              `/accounts/customer_dashboard_details`,
              // { user_id: userId , user_role:user_role},
              { withCredentials: true, headers: { 'Content-Type': 'application/json' },}
            );
            if (response.status === 'expert_details') {
              setshowloader(false)
              setlatestBooking(response.bookings);
              const statsData: blogStatsDataType[] = [
                { title: 'Total Bookings', value: response.bking_count, icon: 'bx bx-calendar' },
                { title: 'Old Bookings', value: response.past_bookings, icon: 'bx bx-calendar-minus' },
                { title: 'New Bookings', value: response.future_bookings, icon: 'bx bx-calendar-plus' },
              ];
        
              setBookingcount(statsData);
            } 
          } catch (error:any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                  console.log('Error in stripe payment')
                  setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" });
                }
                else if (error.response.status === 403) {
                  console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                  console.log('An error occurred')
                  setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
              console.log('An error occurred')
              setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false)
        }
        };
        
        useEffect(() => {
          fetch_bookings();

          subscribeToTokenRefresh(() => {
                console.log("🔁 Token refreshed. Re-fetching experts...");
                fetch_bookings();
              });
        }, []);
      
        useEffect(() => {
          console.log('latestBooking updated:', latestBooking);
        }, [latestBooking]);

  return (
    <React.Fragment>
      <Col lg={8} className="order-lg-1 order-2">
      {alertMsgg.open && (
                  <Alert 
                  color={alertMsgg.type === "success" ? "success" : "danger"} 
                  toggle={handleAlertMsggClose}
                  style={{ fontWeight: "bold" }}
                  >
                  {alertMsgg.content}
                  </Alert>
                  )}
      <div className="loaderContainer" hidden={!showloader}>
              <div className="spinner">
                <div></div>  
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
                <div></div>    
              </div>
            </div>
        <Row>
          {(Bookingcount || [])?.map((stat: blogStatsDataType, index: number) => (
            <Col lg={4} key={index}>
              <Card className="blog-stats-wid rounded-4"> 
                <CardBody>
                  <div className="d-flex flex-wrap">
                    <div className="me-3">
                      <p className="text-muted mb-2 font-size-15">{stat.title}</p>
                      <h5 className="mb-0">{stat.value}</h5>
                    </div>
                    <div className="avatar-sm ms-auto">
                      <div className="avatar-title bg-light rounded-circle text-dark font-size-20">
                        <i className={stat.icon}></i>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
        <Row>
          <Col xl={12}>
            <Card className="rounded-4">
              <CardBody>
                <CardTitle tag="h4" className="mb-4">Latest Booking</CardTitle>
                <TableContainer
                  columns={columns}
                  data={latestBooking}
                  isGlobalFilter={false}
                  tableClass="align-middle table-nowrap mb-0"
                  theadClass="table-light"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};


export default withRouter(LatestBooking);
